import React from 'react';
import brand from "../../images/brand.svg";
import Loader from '../loader/Loader';
import "./BootstrapLoader.scss";

export default function BootstrapLoader(props: {bootstrapErrors: Array<string>}) {
  let loadingState = <>
    <p className="text-center LoaderText">
      Ontotext Platform Workbench is loading 
    </p>
    <Loader block={true} size="lg" />
  </>

  if (props.bootstrapErrors && props.bootstrapErrors.length) {
    loadingState = <div>
      {props.bootstrapErrors.map((error, index) => <h4 key={index} className="text-center text-danger LoaderText">{error}</h4>)}
    </div>
  }

  return (
    <div className="BootstrapLoader">
      <img src={brand} alt="Ontotext Platform Workbench" height="320"/>
      {loadingState}
    </div>
  );
}
